const rDomain = {
  logo: 'img/brand/white1.png',
  icp: ''
}

export default rDomain